import BaseModel from "../../../../../core/components/input-widget/BaseModel";

export default class CurrencyExchangeModel extends BaseModel {
  amount = null;
  code = null;

  rules = {
    amount: 'required',
    code: 'required',
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
